export default __webpack_public_path__ + "static/media/user.9d564696.svg";